import React from 'react';
import Image from 'next/image';
import styled from 'styled-components';
import useWindowSize from '../../hooks/useWindowSize';
import BreakPoints from '../../constants/break-points';
import LinkButton from '../global/linkButton/linkButton';
import Media from '../../models/media';
import Richtext from '../global/richtext/Richtext';
import style from './offerings.module.scss';
import { generateBlurDataURL } from '../../helpers/image-placeholders';

type CustomStyleProps = {
  descriptionIsRightSide: boolean;
  subtitleColor: string;
  backgroundColor: string;
  backgroundImage: Media;
  width: number;
};

type CtaStyleProps = {
  ctaBackgroundColor: string;
  ctaColor: string;
};

const CustomStyles = styled.div`
  .${style.offerings} {
    background-color: ${(styleProps: CustomStyleProps) =>
      styleProps.backgroundColor};
    background-image: ${(styleProps: CustomStyleProps) => `
    ${
      styleProps.backgroundImage
        ? `url(${styleProps.backgroundImage.src})`
        : 'none'
    }
  `};
  }

  .${style.offerings__subtitle} {
    color: ${(styleProps: CustomStyleProps) => styleProps.subtitleColor};
  }

  .${style.offerings__wrapper} {
    flex-direction: ${(styleProps: CustomStyleProps) => {
      if (styleProps.width >= BreakPoints.md)
        return `${styleProps.descriptionIsRightSide ? 'row' : 'row-reverse'}`;

      return '';
    }};
  }
`;

const CtaStyles = styled.div`
  .${style.offerings__button} {
    background-color: ${(styleProps: CtaStyleProps) =>
      styleProps.ctaBackgroundColor};
    color: ${(styleProps: CtaStyleProps) => styleProps.ctaColor};
  }
`;

const Offerings = (props: any) => {
  const { data } = props;
  const { width } = useWindowSize();

  return (
    <CustomStyles
      descriptionIsRightSide={data?.descriptionIsRightSide}
      subtitleColor={data?.subtitleColor}
      backgroundColor={data?.backgroundColor}
      backgroundImage={data?.backgroundImage}
      width={width}
    >
      <div className={style.offerings}>
        <div className={style.offerings__wrapper}>
          <div className={style['offerings__image-container']}>
            {data.image && (
              <Image
                placeholder="blur"
                alt={data.image.alt}
                src={data.image.src}
                layout="responsive"
                height={data.image.height}
                width={data.image.width}
                blurDataURL={generateBlurDataURL(data.image.src)}
              />
            )}
          </div>
          <div className={style['offerings__description-container']}>
            <div className={style['offerings__description-wrapper']}>
              <h1 className={style.offerings__header}>
                {data.offerTitle && (
                  <Richtext
                    data={data.offerTitle}
                    customClasses={{
                      bold: style['offerings__header-secondary'],
                      paragraph: style['offerings__header-text']
                    }}
                  />
                )}
              </h1>
              <h2 className={style.offerings__subtitle}>{data.subtitle}</h2>
              {data.offerDescription && (
                <Richtext
                  data={data.offerDescription}
                  customClasses={{ paragraph: style.offerings__description }}
                />
              )}
              {data.ctaLinks && (
                <div className={style['offerings__cta-container']}>
                  {data.ctaLinks.map((ctaLink: any) => (
                    <CtaStyles
                      key={ctaLink.label}
                      ctaBackgroundColor={ctaLink?.backgroundColor}
                      ctaColor={ctaLink?.textColor}
                    >
                      <LinkButton
                        linkClass={style.offerings__button}
                        data={ctaLink}
                      />
                    </CtaStyles>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </CustomStyles>
  );
};

export default Offerings;
